import { Patient } from '@medplum/fhirtypes';
import { Location } from 'react-router-dom';

function patientPathPrefix(patientId: string): string {
  return `/Patient/${patientId}`;
}

export function prependPatientPath(
  patient: Patient | undefined,
  path: string
): string {
  if (patient?.id) {
    return `${patientPathPrefix(patient.id)}${
      !path.startsWith('/') ? '/' : ''
    }${path}`;
  }

  return path;
}

export function formatPatientPageTabUrl(
  patientId: string,
  tab: PatientPageTabInfo
): string {
  return `${patientPathPrefix(patientId)}/${tab.url.replace(
    '%patient.id',
    patientId
  )}`;
}

export type PatientPageTabInfo = {
  id: string;
  url: string;
  label: string;
};

export function getPatientPageTabOrThrow(tabId: string): PatientPageTabInfo {
  const result = PatientPageTabs.find((tab) => tab.id === tabId);

  if (!result) {
    throw new Error(`Could not find patient page tab with id ${tabId}`);
  }
  return result;
}

export const PatientPageTabs: PatientPageTabInfo[] = [
  {
    id: 'summary',
    url: '',
    label: 'summaryPage.tabs.summary',
  },
  {
    id: 'currentEncounter',
    url: 'current-encounter',
    label: 'summaryPage.tabs.currentEncounter',
  },
  {
    id: 'diagnosis',
    url: 'diagnosis',
    label: 'summaryPage.tabs.diagnosis',
  },
  {
    id: 'encounters',
    url: 'encounters',
    label: 'summaryPage.tabs.encounters',
  },
  {
    id: 'encounterImages',
    url: 'images',
    label: 'summaryPage.tabs.encounterImages',
  },
  {
    id: 'files',
    url: 'files',
    label: 'summaryPage.tabs.files',
  },
  {
    id: 'assignedDoctors',
    url: 'assigned-doctors',
    label: 'summaryPage.tabs.assignedDoctors',
  },
  {
    id: 'orders',
    url: 'orders',
    label: 'summaryPage.tabs.orders',
  },
  {
    id: 'specimens',
    url: 'specimens',
    label: 'summaryPage.tabs.specimens',
  },
];

export function getTabFromLocation(
  location: Location
): PatientPageTabInfo | undefined {
  // Extract the path after /Patient/{id}/
  // e.g., "/Patient/123/files" -> "files"
  const pathParts = location.pathname.split('/');
  const tabPath = pathParts.slice(3).join('/');

  if (!tabPath) {
    // If no path after patient ID, it's the summary tab (empty url)
    return PatientPageTabs.find((t) => t.url === '');
  }

  // With simplified URLs, exact match is sufficient
  return PatientPageTabs.find((t) => t.url === tabPath);
}
